import { CapoPlugin } from "/opt/buildhome/repo/node_modules/.pnpm/@unhead+vue@1.11.20_vue@3.5.28/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];